export const STATE_MAPPINGS = {
  flowsactive: 'app.runner.flowsactive',
  flowstodo: 'app.runner.flowstodo',
  flowsin: 'app.runner.flowsin',
  reports: 'app.runner.reports',
  processmapsv2: 'app.runner.processmapv2',
  libraryworkflows: 'app.runner.library.workflows',
  libraryprocessmaps: 'app.runner.library.processmaps',
  librarydrafts: 'app.runner.library.drafts',
  dashboard: 'app.runner.exagosingle',
  analytics: 'app.runner.exago'
};
